import CommonCheckbox from '@src/components/CommonCheckbox'
import { CatalogType } from '@src/types/graphql-types'
import {
  MAX_COMPARE_SIZE,
  useCompareProducts,
} from '@src/utils/useCompareProducts'
import { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme) => {
  return {
    compareProductContainer: {
      background: theme.palette.background.grey,
      fontSize: theme.typography.pxToRem(14),
      paddingRight: theme.spacing(2),
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
    },
    checkbox: {
      background: theme.palette.background.default,
    },
    label: {
      alignItems: 'center',
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
    },
  }
})

export interface CompareProductCheckboxProps {
  productKey: string
  brandKey: string
  productName: string
  productNumber: string
  catalogType: CatalogType
  images: []
}

export const CompareProductCheckbox = ({
  productKey,
  brandKey,
  productName,
  productNumber,
  images,
  catalogType,
}) => {
  const { classes } = useStyles()
  const [isMounted, setIsMounted] = useState(false)
  useEffect(() => setIsMounted(true), [])

  const { compareProducts, addCompareProduct, removeCompareProduct } =
    useCompareProducts()
  const isCompared = compareProducts.some(
    ({
      productKey: comparedProductKey,
      brandKey: comparedBrandKey,
      catalogType: comparedCatalogType,
    }) =>
      comparedProductKey === productKey &&
      comparedBrandKey === brandKey &&
      comparedCatalogType === catalogType
  )

  const compareDisabled =
    !isCompared && compareProducts.length >= MAX_COMPARE_SIZE
  const productCompareValues = {
    productKey,
    productNumber,
    brandKey,
    images,
    catalogType,
  }

  return (
    <span
      className={classes.compareProductContainer}
      data-testid="compare-product"
    >
      <label className={classes.label}>
        <CommonCheckbox
          className={classes.checkbox}
          data-testid="compare-product-checkbox"
          aria-label={`Compare ${productName}`}
          checked={isMounted && isCompared}
          onChange={(e) => {
            e.target.checked
              ? addCompareProduct(productCompareValues)
              : removeCompareProduct(productCompareValues)
          }}
          disabled={compareDisabled}
        />
        <FormattedMessage
          id="COMPARE_THIS_PRODUCT"
          defaultMessage="Compare This Product"
        />
      </label>
    </span>
  )
}
